function App() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Hello World</h1>
        <p className="text-gray-600">React + Vite + Tailwind CSS</p>
      </div>
    </div>
  );
}

export default App;
